import EditThumbnailModal from './EditThumbnailModal'
export default EditThumbnailModal
